// 자동 로그아웃 직전, 작성 중인 폼이 스스로 임시저장하도록 연결하는 전역 레지스트리.
// 상담일지 등록 폼이 마운트 시 saver 를 등록하고, App 의 handleForceLogout 이
// 로그아웃(토큰/스토리지 삭제) 직전에 실행한다. (토큰은 만료되지 않으므로 이 시점 API 호출 가능)
let draftSaver = null;

export const registerLogoutDraftSaver = (fn) => {
  draftSaver = fn;
};

export const unregisterLogoutDraftSaver = (fn) => {
  // 다른 폼이 이미 덮어쓴 경우엔 건드리지 않음
  if (draftSaver === fn) {
    draftSaver = null;
  }
};

// 로그아웃 직전 호출. 등록된 saver 가 없거나 실패해도 로그아웃은 계속 진행되어야 하므로
// 예외를 삼키고, 네트워크 지연으로 로그아웃이 멈추지 않도록 타임아웃으로 보호한다.
export const runLogoutDraftSaver = async (timeoutMs = 4000) => {
  if (typeof draftSaver !== "function") return;
  try {
    await Promise.race([
      Promise.resolve().then(() => draftSaver()),
      new Promise((resolve) => setTimeout(resolve, timeoutMs)),
    ]);
  } catch (error) {
    console.error("[LogoutDraftSaver] 임시저장 실패:", error);
  }
};
